<script setup lang="ts">
import { isNativePlatform } from '@/application/utils/envInfo';
import HeaderBackButton from '@/application/components/HeaderBackButton.vue';
import DesktopMenu from '@/application/menu/components/DesktopMenu.vue';
import MobileHeaderMenu from '@/application/menu/components/MobileHeaderMenu.vue';
import SkipLink from '@/application/components/SkipLink.vue';
import ProfileButton from '@/application/components/ProfileButton.vue';
import { storeToRefs } from 'pinia';
import { useUserStore } from '@/user/store/userStore';

const { isAuthenticated } = storeToRefs(useUserStore());
</script>

<template>
  <div class="pt-safe bg-white shadow-sm">
    <SkipLink title="Zum Hauptinhalt springen" href="#app-main" />
    <div
      :class="{'pt-1 h-12 md:h-14': !isNativePlatform}"
      class="grid grid-cols-[auto_1fr_auto] md:grid-cols-[1fr_4fr_1fr] items-center gap-2 md:container mx-4 pb-1"
    >
      <div>
        <HeaderBackButton id="header-back-button" class="mr-2" />
      </div>
      <div class="-ml-2">
        <MobileHeaderMenu />
        <DesktopMenu />
      </div>
      <div>
        <ProfileButton v-if="isAuthenticated" />
      </div>
    </div>
  </div>
</template>
